module.exports = __webpack_public_path__ + "static/media/exampleWall.590d7dca.jpg";